import { inject, Pipe, PipeTransform } from '@angular/core';
import { Channel } from '@campaign-portal/namespace/entities/channels/specs';
import { exist, Id, UUID } from '@campaign-portal/namespace/common/id';
import { IdObject } from '@campaign-portal/namespace/common/idObject';
import { ContactGroup } from '@campaign-portal/namespace/entities/contact-groups/specs';
import { SenderSubscription } from '@campaign-portal/namespace/entities/sender-id/specs';
import { MessageTemplate } from '@campaign-portal/namespace/entities/templates/specs';
import { ContactGroupsService, ChannelsService, MessageTemplatesService, SendersService } from '../services';

function findEntity<T>(id: Id<exist> | IdObject<exist>, dataMap: Map<exist | UUID, T>): T | null {
	if (typeof id === 'number') {
		return dataMap.get(id) ?? null;
	}

	if (typeof id === 'object' && !Array.isArray(id)) {
		return dataMap.get(id.id) ?? null;
	}

	return null;
}

@Pipe({
	name: 'channel',
	standalone: true,
})
export class ChannelPipe implements PipeTransform {
	private readonly service = inject(ChannelsService);

	transform(id: Id<exist> | IdObject<exist>): Channel | null {
		return findEntity(id, this.service.map);
	}
}

@Pipe({
	name: 'cGroup',
	standalone: true,
})
export class ContactGroupPipe implements PipeTransform {
	private readonly service = inject(ContactGroupsService);

	transform(id: Id<exist> | IdObject<exist>): ContactGroup | null {
		return findEntity(id, this.service.map);
	}
}

@Pipe({
	name: 'cDeletedGroup',
	standalone: true,
})
export class ContactDeletedGroupPipe implements PipeTransform {
	private readonly service = inject(ContactGroupsService);

	transform(id: Id<exist> | IdObject<exist>): ContactGroup | null {
		return findEntity(id, this.service.removedMap$.getValue());
	}
}

@Pipe({
	name: 'sender',
	standalone: true,
})
export class SenderPipe implements PipeTransform {
	private readonly service = inject(SendersService);

	transform(id: Id<exist> | IdObject<exist>): SenderSubscription | null {
		return findEntity(id, this.service.map);
	}
}

@Pipe({
	name: 'message',
	standalone: true,
})
export class MessageTemplatePipe implements PipeTransform {
	private readonly service = inject(MessageTemplatesService);

	transform(id: Id<exist> | IdObject<exist>): MessageTemplate | null {
		return findEntity(id, this.service.map);
	}
}
